const BigNumber = require('bignumber.js');
import {parseFromTimeZone, formatToTimeZone} from 'date-fns-timezone';
export default {
    isNumber: function(n: any) {
        const type = typeof(n);
        if ( type === 'number' && Number.isFinite(n) ) {
            return true;
        }
        if ( type === 'string' && n.trim() !== '' && Number.isFinite(n - 0) ) {
            return true;
        }
        return false;
    },
    /**
     * 表示上の桁数操作
     * あくまでも表示上のみのことでありデータとしては保存しない事
     * @param amount
     */
    amountFormat: function(amount: number) {
        let floorSize = BigNumber(100000000);// 小数点第8位より先切り捨て
        if (amount > 99999999999999) {
            floorSize = floorSize.div(100000000); // 99999999999999以上の場合小数点は表示しない
        } else if (amount > 9999999999999) {
            floorSize = floorSize.div(10000000);
        } else if (amount > 999999999999) {
            floorSize = floorSize.div(1000000);
        } else if (amount > 99999999999) {
            floorSize = floorSize.div(100000);
        } else if (amount > 9999999999) {
            floorSize = floorSize.div(10000);
        } else if (amount > 999999999) {
            floorSize = floorSize.div(1000);
        } else if (amount > 99999999) {
            floorSize = floorSize.div(100);
        } else if (amount > 9999999) {
            floorSize = floorSize.div(10);
        }
        const base = BigNumber(amount).times(floorSize);
        const result = BigNumber(Math.floor(base.toNumber())).div(floorSize);
        return result.toNumber();
    },

    /**
     * Timestampで返す
     * @param date
     * @param format
     */
    getBlockTime: function(date: string|number, format: string) {
        if (format == 'ISO') {
            return Date.parse(String(date));
        } else if (format == 'timestamp') {
            return date;
        }
    },

    getLocaleDate: function(date: Date, format: string, timezone: string) {
        return formatToTimeZone(date, format, {timeZone: timezone});
    },

    getLocaleDateFromString: function(YmdHis: string, format: string, timezone: string) {
        const date = parseFromTimeZone(YmdHis+'.000', {timeZone: 'UTC'});
        return this.getLocaleDate(date, format, timezone)
    },

    getDate: function(ymdhis: string) {
        const split = ymdhis.split(' ');
        const ymd = split[0];
        console.log('ymd', ymd);
        let his;
        if (split[1]) {
            his = split[1];
        } else {
            his = '00:00:00'
        }
        console.log('his', his);
        const splitYmd = ymd.split('-');
        console.log('splitYmd', splitYmd);
        const year = parseInt(splitYmd[0]);
        const month = parseInt(splitYmd[1]);
        const date = (splitYmd[2]) ? parseInt(splitYmd[2]): 1;
        const splitHis = his.split(':');
        console.log('splitHis', splitHis);

        const hours = (splitHis[0]) ? parseInt(splitHis[0]) : 0;
        const minutes = (splitHis[1]) ? parseInt(splitHis[1]) : 0;
        const seconds = (splitHis[2]) ? parseInt(splitHis[2]) : 0;
        return new Date(year, month, date, hours, minutes, seconds);
    },

    /**
     * バージョンナンバー(X.YYY.ZZZ)の大小を比較するため
     * Y,Zの数字をそれぞれ0paddingした3桁の数字に置き換えて10**6倍して返す
     * @param version
     */
    versionNumber: function(version: string|number) {
        let res = '';
        let verStr = '';
        if (typeof version == 'number') {
            verStr = String(version);
        } else {
            verStr = version;
        }
        const split = verStr.split('.');
        res = split[0] + '.';
        if (split[1]) {
            res = res + split[1].padStart(3, '0');
        } else {
            res = res + '000';
        }
        if (split[2]) {
            res = res + split[2].padStart(3, '0');
        } else {
            res = res + '000';
        }
        return BigNumber(parseFloat(res)).times(10**6).toNumber();
    }
}
